module.exports = __webpack_public_path__ + "img/wxcode.006f2f92.jpg";